/**
 * RouteAnnouncer — Screen reader announcements for route changes
 *
 * Uses an aria-live region to announce page transitions to assistive technology.
 * Without this, screen reader users have no indication that the page content changed
 * after a client-side navigation.
 *
 * Convoy-050 gt-ux019 — Accessibility Audit
 */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

/** Map known paths to human-readable page names */
function getPageTitle(pathname: string): string {
  const pathMap: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/entities': 'Entities',
    '/documents': 'Documents',
    '/compliance': 'Compliance',
    '/approvals': 'Approvals',
    '/delegations': 'Delegations',
    '/portfolio-operations': 'Portfolio Operations',
    '/shared-links': 'Shared Links',
    '/subprocessor-monitors': 'Subprocessor Monitors',
    '/analytics': 'Analytics',
    '/developer': 'Developer',
    '/settings': 'Settings',
    '/profile': 'Profile',
    '/login': 'Login',
    '/register': 'Register',
    '/pricing': 'Pricing',
    '/privacy': 'Privacy Policy',
    '/terms': 'Terms of Service',
    '/dpa': 'Data Processing Agreement',
    '/enterprise-admin': 'Enterprise Admin',
  };

  return pathMap[pathname] || 'Page';
}

export function RouteAnnouncer() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    const title = getPageTitle(location.pathname);
    setAnnouncement(`Navigated to ${title}`);
  }, [location.pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="absolute w-px h-px p-0 -m-px overflow-hidden whitespace-nowrap border-0"
      style={{ clip: 'rect(0, 0, 0, 0)' }}
    >
      {announcement}
    </div>
  );
}
